import yqz from './yqz';


export default {
    path: 'yqz',
    component: () => import('@layout/empty'),
    children: [
        yqz,
    ]
}